<template>
  <svg class="graph" width="100%" :height="height">
    <g transform>
      <axis orientation="bottom" :scale="scaleX" :tick-size-inner="height" :ticks="max" :opacity="0.1" padded-index></axis>
      <axis orientation="left" :scale="scaleY" :tick-size-inner="intWidth" :offset-x="intWidth" :opacity="0.1"></axis>

      <line v-if="pre" :scale-x="scaleX" :scale-y="scaleY" key-y="answer" :data="pre" stroke="#ccc"></line>
      <line v-if="post" :scale-x="scaleX" :scale-y="scaleY" key-y="answer" :data="post" stroke="#ff5216" :stroke-width="3"></line>
    </g>
  </svg>
</template>

<script>
import { scaleLinear } from 'd3-scale'

import Axis from 'components/Axis'
import Line from 'components/Line'

export default {
  name: 'Graph',
  components: {
    Axis, Line
  },
  props: {
    height: {
      type: Number,
      default: 600
    },
    pre: {
      type: [Array, Boolean],
      default () {
        return []
      }
    },
    post: {
      type: [Array, Boolean],
      default () {
        return []
      }
    }
  },
  data () {
    return {
      width: 750
    }
  },
  computed: {
    scaleX () {
      return scaleLinear()
      .domain([0, this.max - 1])
      .range([0, this.width])
    },
    intWidth () {
      return parseInt(this.width)
    },
    max () {
      return this.pre.length > this.post.length ? this.pre.length : this.post.length
    },
    scaleY () {
      return scaleLinear()
      .domain([5, 1])
      .range([0, this.height])
    }
  },
  methods: {
    resize () {
      this.width = this.$el.getBoundingClientRect().width
      console.log('this.width', this.width)
    }
  },
  ready () {
    window.addEventListener('resize', this.resize)
    setTimeout(() => this.resize(), 500)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="scss" scoped>
svg {
  overflow: visible;
  margin-bottom: 4rem;
}
path {
  fill: none;
}
</style>


// WEBPACK FOOTER //
// Graph.vue?68da42ef